export default __webpack_public_path__ + "static/logo_leathersta-f5d51895055bc24365311b9bd534c05f.png";